import React from 'react';
import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function FloatingWhatsApp() {
  return <motion.a href="https://wa.me/5491168898054" target="_blank" rel="noopener noreferrer" initial={{
    scale: 0
  }} animate={{
    scale: 1
  }} transition={{
    type: 'spring',
    stiffness: 260,
    damping: 20,
    delay: 1
  }} className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300" aria-label="Contactar por WhatsApp" data-id="element-204">
      <MessageCircle className="w-8 h-8 text-white fill-white" data-id="element-205" />

      {/* Pulse effect */}
      <div className="absolute inset-0 rounded-full border-2 border-[#25D366] animate-ping opacity-75" data-id="element-206"></div>
    </motion.a>;
}